import React, { useState } from "react";
import styled from "styled-components";
import SingleFilter from "./FilterCategory";
import { FILTER_NAME_TO_KEY } from "../../util/DormFilter.js";
import map from "../../assets/Icons/map.svg"
import sort from "../../assets/Icons/sort.svg"

let FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  padding: 0rem 1.2rem 0.6rem 0rem;
  //background-color: ${(props) => props.theme.columbiaBlue};
  //background-color: #999CCC;
  @media only screen and (max-width: 769px) {
    justify-content: center;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 0rem;
  }
`;

const Filters = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const FiltersWrapper = styled.div`
  display: flex;
  // gap: 10px;
  color: #3B81B4;
  @media only screen and (max-width: 769px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const MapButtonsWrapper = styled.div`
  display: none;
  @media only screen and (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem;
}
`;

const MapButton = styled.a`
  cursor: pointer;
  text-decoration: underline;
  padding: 0.5rem;
  color: #3B81B4 !important;
  background-color: white;
  border-radius: 10px;
  border: 1px solid #3B81B4;
  display: flex;
  align-items: center;
  padding: 0.3rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  gap: 10px;
`;

let Textbox = styled.div`
  font-family: "Raleway";
  font-size: 1rem;
  color: #3B81B4;
  padding-right: 1rem;
  height: fit-content;
  margin: auto 0rem;
`;

let ClearButton = styled.a`
  cursor: pointer;
  text-decoration: underline;
  padding-left: 1rem;
`;

const FilterBar = (props) => {
  const [openFilters, setOpenFilters] = useState([0, 0, 0, 0]);
  const [selectedFilters, setSelectedFilters] = useState([0, 0, 0, 0]);

  const clear = () => {
    setOpenFilters([0, 0, 0, 0]);
    setSelectedFilters([0, 0, 0, 0]);
    props.reset();
  };

  const getFilters = () => {
    return Object.keys(props.filterElements).map((filterName, i) => {
      // Create an array of the filters within the category that are selected
      let categoryFilters = props.filterElements[filterName];
      let categoryPayload = categoryFilters.filter(
        (filter) => !!props.payload[FILTER_NAME_TO_KEY[filter]]
      );
      //console.log("filters: ", categoryFilters);
      //console.log("payload: ", categoryPayload);

      return (
        <SingleFilter
          key={i}
          i={i}
          open={openFilters[i]}
          selected={selectedFilters[i]}
          handleChange={props.handleChange}
          headerTitle={filterName}
          filters={categoryFilters}
          payload={categoryPayload}
          note={props.filterNotes?.[filterName]}
        />
      );
    });
  };

  return (
    <FilterRow>
      <Filters>
        <FiltersWrapper>
          <Textbox>Filters</Textbox>
          {getFilters()}
          <Textbox>
            <ClearButton onClick={() => clear()}>Clear</ClearButton>
          </Textbox>
        </FiltersWrapper>
      </Filters>
      <MapButtonsWrapper>
        {!props.mapOpen && 
          <MapButton
            onClick={props.toggleMap}
          >
            <img src={map} />
            See Map
          </MapButton>}
        <MapButton>
          <img src={sort} />
          Sort
        </MapButton>
      </MapButtonsWrapper>
    </FilterRow>
  );
};

export default FilterBar;
